import type { Json } from '@/integrations/supabase/types';

/**
 * Normalize an arbitrary serializable value into the Supabase `Json` type for
 * writing to a `jsonb` column.
 *
 * Some payloads (diagnostic snapshots, audit records) are built from strongly
 * typed interfaces whose nested arrays/objects TypeScript will not structurally
 * accept as `Json`, even though every field is JSON-serializable at runtime.
 * Rather than assert the type away, this round-trips through `JSON` so the
 * result is provably a plain JSON value — the same shape the database stores —
 * and returns it under the honest `Json` type. Values that cannot serialize
 * (undefined, functions) are dropped by `JSON.stringify`, exactly as they would
 * be by the network layer.
 */
export function toJson<T>(value: T): Json {
  return JSON.parse(JSON.stringify(value ?? null));
}
